import React from "react";

export type IMPERSONATE_CONTEXT = {
  canSwitchUser: boolean,
  enabledFeature: string,
  firstName: string
  isSwitch: boolean
  userName: string
}

const defaultValue: IMPERSONATE_CONTEXT = {
  canSwitchUser: false,
  enabledFeature: '', //Left a portion of the code as a guide for any future feature-aware implementations, do not delete in the future.
  firstName: '',
  isSwitch: false,
  userName: ''
};

export const ImpersonateContext = React.createContext(defaultValue);
